<template>
  <div class="step_container"
      :style="{
      '--borderColor': borderColor,
    }">
    <div class="row">
      <div class="col-sm-6 col-12" :key="idx" v-for="(step, idx) in steps">
        <div class="step_wrapper">
          <div class="step" :class="{ first: idx % 2 === 0 }">
            <div class="d-flex align-items-center">
              <img :src="getImgUrl(step.image)" />
              <div class="content">
                <h3 v-html="step.title" :style="{ color: textColor }"></h3>
                <span v-html="step.text"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "steps-horizontal",
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    textColor: {
      type: String,
      default: "#f2ac29"
    },
    borderColor: {
     required: false,
      type: String,
      default: "#ebf0fa"
    },
    campaign: {
      type: String,
      default: ""
    }
  },
  methods: {
    getImgUrl(image) {
      // console.log(this.borderColor);
      var images = require.context("../../assets/icons/campaigns", true, /\.svg$/);
      return images(`./${this.campaign}/${image}.svg`);
    }
  }
};
</script>

<style scoped lang="scss">
.step_wrapper {
  @media (max-width: 767px) {
    display: flex;
    justify-content: center;
  }
}

.step_container {
  [class*="col-"]:not(:last-child) {
    margin-bottom: 30px;
  }
}

.step {
  width: 440px;
  height: 160px;
  background: #ffffff;
  border: 1px solid var(--borderColor);
  box-sizing: border-box;
  border-radius: 16px;
  padding: 35px;

  @media (min-width: 767px) {
    &.first {
      float: right;
    }
  }

  img {
    width: 56px;
    height: 70px;
  }
  .content {
    margin-left: 20px;
  }

  h3 {
    font-weight: 800;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  @media (max-width: 767px) {
    width: 3354px;
    height: 123px;
    padding: 30px;

    img {
      width: 36px;
      height: 45px;
    }

    h3 {
      font-size: 18px;
      line-height: 20px;
    }

    span {
      font-size: 14px;
      line-height: 15px;
    }
  }
  @media (max-width: 450px) {
    h3 {
      font-size: 16px;
      line-height: 20px;
    }
    span {
      font-size: 12px;
      line-height: 15px;
    }
  }

}
</style>
